import { useEffect, useState } from 'react'
import { sortBy, cloneDeep } from 'lodash'
import { useNavigate } from 'react-router-dom'

import {
  useUser,
  useSessionWS,
  useTrkptsWS,
  useListSessionsWS,
  useRestricted,
  useListBoards,
  useListSails,
  useLang,
} from '../utils/hooks'

import {
  sessionsNumberOfItemsPerPage,
  k_session_removed,
  textClass,
} from '../assets/colors'

// import { freeAccount, noAccount, subscribeAccount } from '../assets/accounts'
import * as Const from '../assets/accounts'

import SessionList from '../components/SessionList'
import PageSelect from '../components/PageSelect'
import SessionModify from '../components/SessionModify'
import RemoveSessionModal from '../components/RemoveSessionModal'
import Help from '../components/Help'
import HelpNotif from '../components/HelpNotif'

import { MapContainer, TileLayer, Polygon } from 'react-leaflet'
import ChangeView from '../components/ChangeView'

import { LoaderWrapper, Loader } from '../components/StyledElements'

import { langSessions } from '../assets/langSessions'
import Footer from '../components/Footer'
import DoFetch from '../components/DoFetch'
import React from 'react'
import DoDeleteSession from '../components/DoDeleteSession'
import { useRef } from 'react'
import { callApiGet } from '../assets/assets_functions'

const Sessions = () => {
  const blueOptions = { color: 'blue', weight: '1' }
  const nbFreeMaxSessions = process.env.REACT_APP_FREE_MAX_SESSIONS
  const nbSubscribeMaxSessions =
    process.env.REACT_APP_SUBSCRIBE_MAX_SESSIONS_PER_YEAR
  const demoUserName = process.env.REACT_APP_DEMO_USERNAME

  const freeAccount = Const.freeAccount
  const subscribeAccount = Const.subscribeAccount
  const noAccount = Const.noAccount

  const SORTS = {
    NONE: (list) => list,
    SESSION_SORT: (list) => sortBy(list, 'sessionTitle'),
    DATE_SORT: (list) => sortBy(list, 'sessionStart'),
    DUREE_SORT: (list) => sortBy(list, 'sessionDuration'),
    R_DUREE_SORT: (list) => sortBy(list, 'restrictedSessionDuration'),
    METEO_SORT: (list) => sortBy(list, 'meteoStationId'),
  }

  let navigateTo = useNavigate()

  const firstDiv = useRef(null)

  //states
  const { user, changeUser } = useUser()
  const { lang } = useLang()
  const { listSessionsWS, setListSessionsWS } = useListSessionsWS()
  const { sessionWS, changeSessionWS } = useSessionWS()
  const { changeTrkptsWS } = useTrkptsWS()
  const [sessionInfos, setSessionInfos] = useState('')
  const { restricted } = useRestricted()
  const [datas, setDatas] = useState({
    center: null,
    polygon: null,
  })

  const [removeModal, setRemoveModal] = useState({
    removeModalIsOpen: false,
    removeTitle: '',
  })
  const [isDeleting, setIsDeleting] = useState(false)
  const [sessionDeleteResult, setSessionDeleteResult] = useState(null)
  const { listBoards, setListBoards } = useListBoards()
  const { listSails, setListSails } = useListSails()

  const [boardsFetchDatas, setBoardsFetchDatas] = useState(null)
  const [sailsFetchDatas, setSailsFetchDatas] = useState(null)
  const [sessionsFetchDatas, setSessionsFetchDatas] = useState(null)

  const [modifiedSession, setModifiedSession] = useState({})
  const [okSession, setOkSession] = useState({ titleOk: true })
  const [showModify, setShowModify] = useState(false)
  const [showHelp, setShowHelp] = useState(false)
  const [addAuthorized, setAddAuthorized] = useState(false)

  const choosenLang = lang === 'eng' ? langSessions.eng : langSessions.fr

  //effects

  useEffect(() => {
    if (firstDiv.current !== null) {
      const topScroll = firstDiv.current.getBoundingClientRect().top
      window.scrollTo({ top: topScroll.current - 120, behavior: 'smooth' })
    }
  }, [])

  useEffect(() => {
    if (user.userId === -1) {
      const localUserName = localStorage.getItem('wsurf_userName')
      const localUserId = localStorage.getItem('wsurf_userId')
      const localAccountType = localStorage.getItem('wsurf_accountType')
      const localSubscribeStart = localStorage.getItem('wsurf_subscribeStart')
      const localSubscribeEnd = localStorage.getItem('wsurf_subscribeEnd')

      if (!localUserId || Number(localUserId) === -1) {
        changeUser({
          userName: '',
          userId: -1,
          accountType: noAccount,
          subscribeStart: null,
          subscribeEnd: null,
          subscribeLength: null,
        })
        localStorage.setItem('wsurf_userName', '')
        localStorage.setItem('wsurf_userId', '-1')
        localStorage.setItem('wsurf_subscribeAccount', noAccount)
        localStorage.setItem('wsurf_subscribeStart', '')
        localStorage.setItem('wsurf_subscribeEnd', '')
        navigateTo('/login')
      } else {
        changeUser({
          userName: localUserName,
          userId: localUserId,
          accountType: localAccountType,
          subscribeStart: new Date(localSubscribeStart),
          subscribeEnd: new Date(localSubscribeEnd),
        })
      }
    }
  }, [])

  useEffect(() => {
    if (user.userId === -1) return
    if (listSessionsWS.initialData.length !== 0) return

    const userLimit =
      user.accountType === subscribeAccount ? 0 : nbFreeMaxSessions
    setListSessionsWS({ type: 'SESSIONS_FETCH_INIT' })
    const url = '/api/sessionWS/getSessionsForUser'
    const userId = user.userId

    const data = { userId, userLimit }
    const fetchDatas = { url: url, postData: data }

    callApiGet(fetchDatas)
      .then((data) => {
        // const temp_authorized =
        //   (user.accountType === subscribeAccount &&
        //     data.length < nbSubscribeMaxSessions) ||
        //   data.length < nbFreeMaxSessions
        data.forEach((temp) => (temp.bg = ''))
        setListSessionsWS({ type: 'SESSIONS_FETCH_OK', payload: data })
        setSessionsFetchDatas(null)
        //setAddAuthorized(temp_authorized)
      })
      .catch((error) => {
        console.log('Error getting sessions for user', error)
        setListSessionsWS({ type: 'SESSIONS_FETCH_FAILED' })
      })
  }, [user])

  useEffect(() => {
    if (user.userId === -1) return
    if (listBoards.initialData.length !== 0) return

    setListBoards({ type: 'BOARDS_FETCH_INIT' })
    const url = '/api/board/getBoardsForUser'
    const userId = user.userId
    const data = { userId }
    const fetchDatas = { url: url, postData: data }

    callApiGet(fetchDatas)
      .then((data) => {
        data.forEach((temp) => (temp.bg = ''))
        setListBoards({ type: 'BOARDS_FETCH_OK', payload: data })
        setBoardsFetchDatas(null)
      })
      .catch((error) => {
        console.log('Error getting boards for user', error)
        setListSails({ type: 'BOARDS_FETCH_FAILED' })
      })
  }, [user])

  useEffect(() => {
    if (user.userId === -1) return
    if (listSails.initialData.length !== 0) return

    setListSails({ type: 'SAILS_FETCH_INIT' })
    const url = '/api/sail/getSailsForUser'
    const userId = user.userId
    const data = { userId }
    const fetchDatas = { url: url, postData: data }

    callApiGet(fetchDatas)
      .then((data) => {
        data.forEach((temp) => (temp.bg = ''))
        setListSails({ type: 'SAILS_FETCH_OK', payload: data })
        setSailsFetchDatas(null)
      })
      .catch((error) => {
        console.log('Error getting sails for user', error)
        setListSails({ type: 'SAILS_FETCH_FAILED' })
      })
  }, [user])

  useEffect(() => {
    //if (listSessionsWS.initialData.length === 0) return
    if (user.userId === -1) return
    if (user.accountType === freeAccount) {
      setAddAuthorized(listSessionsWS.initialData.length < nbFreeMaxSessions)
    } else if (user.accountType === subscribeAccount) {
      const subscribeStart = new Date(user.subscribeStart)
      const temp_sessions = listSessionsWS.initialData.filter((session) => {
        return (
          new Date(session.sessionStart).getTime() >= subscribeStart.getTime()
        )
      })

      setAddAuthorized(temp_sessions.length < nbSubscribeMaxSessions)
    }
  }, [listSessionsWS, user])

  useEffect(() => {
    if (!sessionWS) return
    const myLatMin = parseFloat(
      restricted ? sessionWS.restrictedSessionMinLat : sessionWS.sessionMinLat,
    )
    const myLatMax = parseFloat(
      restricted ? sessionWS.restrictedSessionMaxLat : sessionWS.sessionMaxLat,
    )
    const myLngMin = parseFloat(
      restricted ? sessionWS.restrictedSessionMinLng : sessionWS.sessionMinLng,
    )
    const myLngMax = parseFloat(
      restricted ? sessionWS.restrictedSessionMaxLng : sessionWS.sessionMaxLng,
    )
    const myLatMoy = (myLatMin + myLatMax) / 2
    const myLngMoy = (myLngMin + myLngMax) / 2
    const center = [myLatMoy, myLngMoy]
    const polygon = [
      [myLatMax, myLngMax],
      [myLatMax, myLngMin],
      [myLatMin, myLngMin],
      [myLatMin, myLngMax],
    ]
    setDatas({ center, polygon })
  }, [sessionWS, restricted])

  //Sessions handles
  const handleSortSessions = (column_type) => {
    if (column_type !== '') {
      const sort_order =
        column_type === listSessionsWS.sortOrder.sortType
          ? !listSessionsWS.sortOrder.isReverse
          : true
      let sort_type = column_type
      if (column_type === 'DUREE_SORT' && restricted) sort_type = 'R_DUREE_SORT'
      const sortFunction = SORTS[sort_type]
      const temp = sort_order
        ? sortFunction(Array.from(listSessionsWS.data)).reverse()
        : sortFunction(Array.from(listSessionsWS.data))
      setListSessionsWS({
        type: 'SORT_CHANGED',
        payload: {
          list: temp,
          sort: { sortType: column_type, isReverse: sort_order },
        },
      })
    }
  }

  const handleSelectNewItem = (item) => {
    const temp = cloneDeep(listSessionsWS.data)
    const old_index = temp
      .map(function (e) {
        return e.bg
      })
      .indexOf('selected')
    const new_index = temp
      .map(function (e) {
        return e._id
      })
      .indexOf(item._id)

    if (old_index !== -1) {
      temp[old_index].bg = ''
    }

    if (old_index !== new_index) {
      temp[new_index].bg = 'selected'
      changeSessionWS(item)
    } else {
      changeSessionWS(null)
    }
    changeTrkptsWS({ brut: [], restricted: [], origin: '' })
    setSessionInfos('')
    setListSessionsWS({ type: 'NEW_ITEM_SELECTED', payload: temp })
  }

  const handleRemoveItem = () => {
    setRemoveModal({
      removeModalIsOpen: true,
      removeTitle: sessionWS.sessionTitle,
    })
  }

  //Add files handles
  const handleOnAdd = () => {
    changeSessionWS(null)
    changeTrkptsWS({ brut: [], restricted: [], origin: '' })
    navigateTo(`/try/add`)
  }

  //Search input handles
  const handleSearchInputChange = (event) => {
    changeSessionWS(null)

    const temp_searchValue = event ? event.target.value : ''
    let temp_data = [...listSessionsWS.initialData]
    if (temp_searchValue !== '') {
      temp_data = temp_data.filter((o) =>
        Object.keys(o)
          .filter(
            (k) =>
              k === 'sessionTitle' ||
              k === 'sessionStart' ||
              k === 'sessionComments',
          )
          .some((k) =>
            o[k]
              .toString()
              .toLowerCase()
              .includes(temp_searchValue.toLowerCase()),
          ),
      )
    }
    setListSessionsWS({
      type: 'SEARCH',
      payload: { data: temp_data, searchValue: temp_searchValue },
    })
  }

  const handleEscSearch = () => {
    changeSessionWS(null)
    setListSessionsWS({
      type: 'SEARCH',
      payload: { data: listSessionsWS.initialData, searchValue: '' },
    })
  }

  //Pages handles
  const handleClickSelectPage = (num_page) => {
    setListSessionsWS({ type: 'NEW_PAGE', payload: parseInt(num_page) })
  }

  //nav
  const handleNavigateToStats = () => {
    //navigateTo('/oneSessionStats/')  ici pour non stats2
    navigateTo('/oneSessionStats2/')
  }

  //Modify modal handles

  const handleActualizeModifyModal = () => {
    if (
      modifiedSession.sessionTitle !== sessionWS.sessionTitle ||
      modifiedSession.sessionComments !== sessionWS.sessionComments
    ) {
      const sessionId = sessionWS._id
      const sessionTitle = modifiedSession.sessionTitle
      const sessionComments = modifiedSession.sessionComments
      const url = '/api/sessionWS/updateSessionWS'
      const data = { sessionId, sessionTitle, sessionComments }

      fetch(url, {
        method: 'post',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
      })
        .then((response) => {
          const temp = Array.from(listSessionsWS.data)
          const temp_index = temp.findIndex(
            (session) => session._id === sessionWS._id,
          )
          temp[temp_index].sessionTitle = sessionTitle
          temp[temp_index].sessionComments = sessionComments
          setListSessionsWS({ type: 'CHANGED_SESSION_TITLE', payload: temp })
          changeSessionWS({
            ...sessionWS,
            sessionTitle: sessionTitle,
            sessionComments: sessionComments,
          })
        })
        .catch((error) => {
          console.log('update session md', error)
        })
      setModifiedSession({})
    }
    setShowModify(false)
  }

  const handleSessionChange = (e) => {
    const id = e.target.id
    const value = e.target.value
    switch (id) {
      case 'title':
        setOkSession({ ...okSession, titleOk: value.length >= 3 })
        setModifiedSession({ ...modifiedSession, sessionTitle: value })
        break
      case 'comments':
        setModifiedSession({ ...modifiedSession, sessionComments: value })
        break
      default:
        break
    }
  }

  const handleModifyItem = () => {
    const temp = cloneDeep(sessionWS)
    setModifiedSession(temp)
    setShowModify(true)
  }

  const handleCancelModify = () => {
    setModifiedSession({})
    setOkSession({ ...okSession, titleOk: true })
    setShowModify(false)
  }

  const handleCloseRemoveModal = () => {
    setRemoveModal({
      removeModalIsOpen: false,
      removeTitle: '',
    })
  }

  const handleDoDeleteSession = () => {
    setIsDeleting(true)
    DoDeleteSession(sessionWS).then((result) => {
      handleSessionDeleteResult(result)
    })
  }

  const handleSessionDeleteResult = (deleteResult) => {
    setIsDeleting(false)
    handleCloseRemoveModal()
    switch (deleteResult.result) {
      case k_session_removed:
        const temp_data = cloneDeep(listSessionsWS.initialData)
        const temp_index = temp_data.findIndex((element) => {
          return element._id === sessionWS._id
        })
        temp_data.splice(temp_index, 1)

        setListSessionsWS({
          type: 'REMOVE_SESSION',
          payload: temp_data,
        })
        changeSessionWS(null)
        break
      default:
        alert(deleteResult.result + ' sessionId: ' + deleteResult.sessionId)
        break
    }
  }

  const handleSessionsFetch = ({ isLoading, data, error }) => {
    if (data) {
      const temp_authorized =
        (user.accountType === subscribeAccount &&
          data.length < nbSubscribeMaxSessions) ||
        data.length < nbFreeMaxSessions
      data.forEach((temp) => (temp.bg = ''))
      setListSessionsWS({ type: 'SESSIONS_FETCH_OK', payload: data })
      setSessionsFetchDatas(null)
      setAddAuthorized(temp_authorized)
    }
    if (error) {
      console.log('Error getting sessions for user', error)
      setListSessionsWS({ type: 'SESSIONS_FETCH_FAILED' })
    }
  }

  const handleBoardsFetch = ({ isLoading, data, error }) => {
    if (data) {
      data.forEach((temp) => (temp.bg = ''))
      setListBoards({ type: 'BOARDS_FETCH_OK', payload: data })
      setBoardsFetchDatas(null)
    }
    if (error) {
      console.log('Error getting boards for user', error)
      setListBoards({ type: 'BOARDS_FETCH_FAILED' })
    }
  }

  const handleSailsFetch = ({ isLoading, data, error }) => {
    if (data) {
      data.forEach((temp) => (temp.bg = ''))
      setListSails({ type: 'SAILS_FETCH_OK', payload: data })
      setSailsFetchDatas(null)
    }
    if (error) {
      console.log('Error getting sails for user', error)
      setListSails({ type: 'SAILS_FETCH_FAILED' })
    }
  }

  const handleHelp = (what) => {
    setShowHelp(what)
  }

  /* const callApiSessionTimeU = (sessionId, rStartU, rEndU) => {
    const url = '/api/sessionWS/updateSessionTimeU'
    const data = { sessionId, rStartU, rEndU }
    return new Promise((resolve, reject) => {
      fetch(url, {
        method: 'post',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
      })
        .then((response) => {
          console.log('session lmise à jour ' + sessionId)
        })
        .catch((error) => {
          console.log('Error updating session timeu  ' + sessionId, error)
          reject(error)
        })
    })
  } */

  /* const handle_update_sessions_timeU = () => {
    const url = '/api/sessionWS/getAllSessionsWS'
    fetch(url, {
      method: 'post',
      headers: {
        method: 'post',
        headers: { 'Content-Type': 'application/json' },
      },
    })
      .then((response) => {
        response.json().then((sessions) => {
          let promises = []
          sessions.forEach((session) => {
            const sessionId = session._id
            const restrictedStartSession = session.restrictedStartSession
            const restrictedSessionDuration = session.restrictedSessionDuration
            const rStartU = new Date(restrictedStartSession).getTime()
            const rEndU = rStartU + restrictedSessionDuration * 1000
            promises.push(callApiSessionTimeU(sessionId, rStartU, rEndU))
          })
          Promise.all(promises)
            .then((datas) => {
              console.log('ok')
            })
            .catch((error) => {
              if (error.response) {
                console.log('Error updating session timeU ')
                console.log(error.response.data)
                console.log(error.response.status)
                console.log(error.response.headers)
              }
            })
        })
      })
      .catch((error) => {
        console.log('Error getting sessions for user', error)
        setListSails({ type: 'SAILS_FETCH_FAILED' })
      })
  } */

  return (
    <>
      {sessionsFetchDatas && (
        <DoFetch
          fetchDatas={sessionsFetchDatas}
          handleFetch={handleSessionsFetch}
        />
      )}
      {boardsFetchDatas && (
        <DoFetch
          fetchDatas={boardsFetchDatas}
          handleFetch={handleBoardsFetch}
        />
      )}
      {sailsFetchDatas && (
        <DoFetch fetchDatas={sailsFetchDatas} handleFetch={handleSailsFetch} />
      )}

      {listSessionsWS && (
        <section className="section" ref={firstDiv}>
          <div className="columns">
            <div className="column is-7">
              <h1 className="subtitle is-4 has-text-info-dark has-text-weight-semibold">
                {choosenLang.sessions + '   '}
              </h1>

              {listSessionsWS.isError && (
                <p>Something went wrong while loading sessions...</p>
              )}
            </div>
            <div className="column">
              {!showHelp && listSessionsWS.initialData.length > 0 && (
                <Help handleHelp={handleHelp} />
              )}
              {showHelp && (
                <HelpNotif
                  handleHelp={handleHelp}
                  helpText={choosenLang.help}
                />
              )}
            </div>
          </div>
          <div className="columns">
            <div className="column ">
              {
                listSessionsWS.isLoading ? (
                  <LoaderWrapper>
                    <Loader data-testid="loader" />
                  </LoaderWrapper>
                ) : (
                  /* listSessionsWS.initialData.length !== 0 && ( */
                  <div className="block">
                    <SessionList
                      list={listSessionsWS}
                      handleSelectNewItem={handleSelectNewItem}
                      handleRemoveItem={handleRemoveItem}
                      handleModifyItem={handleModifyItem}
                      handleOnAdd={handleOnAdd}
                      handleSort={handleSortSessions}
                      restricted={restricted}
                      handleSearchInputChange={handleSearchInputChange}
                      handleEscSearch={handleEscSearch}
                      choosenLang={choosenLang}
                      buttonsActive={!showModify}
                      addAuthorized={addAuthorized}
                      disabledDemo={user.userName === demoUserName}
                      textClass={textClass}
                    />
                    <PageSelect
                      handleClickSelectPage={handleClickSelectPage}
                      list={listSessionsWS}
                      itemsPerPage={sessionsNumberOfItemsPerPage}
                      choosenLang={choosenLang}
                      buttonsActive={!showModify}
                    />
                  </div>
                )
                /* ) */
              }
            </div>
            <div className="column">
              {showModify && (
                <SessionModify
                  session={modifiedSession}
                  okSession={okSession}
                  handleSessionChange={handleSessionChange}
                  handleCancelModify={handleCancelModify}
                  handleActualize={handleActualizeModifyModal}
                  disabledDemo={user.userName === demoUserName}
                />
              )}
              {datas.center && sessionWS && !showModify && (
                <>
                  <div className="block mt-6 mb-2">
                    <div className="tag is-warning">
                      {sessionWS.sessionTitle}
                    </div>

                    <MapContainer
                      scrollWheelZoom={true}
                      maxZoom={18}
                      zoomOffset={-1}
                    >
                      <ChangeView
                        center={datas.center}
                        origin={'sessions'}
                        map_bounds={datas.polygon}
                        map_path={null}
                      />
                      <TileLayer
                        attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                        zIndex="0"
                      />

                      <Polygon
                        pathOptions={blueOptions}
                        positions={datas.polygon}
                      />
                    </MapContainer>
                    <span className="is-size-7">
                      {choosenLang.sourceFile + sessionWS.fileName}
                    </span>
                  </div>
                  <div className="grid">
                    <div className="cell is-col-span-3">
                      <div className="block is-size-7">
                        {sessionWS.sessionComments &&
                          sessionWS.sessionComments !== '' && (
                            <p>{sessionWS.sessionComments}</p>
                          )}
                      </div>
                    </div>
                    <div className="cell">
                      <div className="block ">
                        <button
                          className="button is-info  is-normal has-text-white has-text-weight-semibold "
                          onClick={() => handleNavigateToStats()}
                        >
                          {choosenLang.toStats}
                        </button>
                        {/* <button
                      className="button is-link"
                      onClick={() => handle_update_sessions_timeU()}
                    >
                      Update durations
                    </button> */}
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>

          {removeModal.removeModalIsOpen && (
            <>
              <RemoveSessionModal
                options={removeModal}
                isDeleting={isDeleting}
                handleClose={handleCloseRemoveModal}
                handleDoDelete={handleDoDeleteSession}
              />
            </>
          )}
        </section>
      )}
      <Footer />
    </>
  )
}

export default Sessions
